import { type actionComponent, type actionType } from '@components/utils/right-panel/utils';
import { type PreloadableComponent, ReactLazyPreload } from '@routes/route-component';
import { type JSX } from 'react';

export const rightSectionComponentMap = {
	'select-party': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/SelectParty')),
		},
	],
} as Partial<
	Record<
		actionComponent,
		{
			action: actionType[];
			component: PreloadableComponent<() => JSX.Element>;
		}[]
	>
>;
